import { Play } from '@tunasong/icons'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './reharm-ab-toggle.module.css'

export type AbMode = 'original' | 'reharm'

export interface ReharmAbToggleProps {
  hasReharm: boolean
  abMode: AbMode
  onModeChange: (mode: AbMode) => void
  onPlay: () => void
}

/**
 * A/B toggle + Play button. Before any substitution is applied, shows a
 * single "Hear original" button. Once a substitution lands, splits into a
 * 2-segment radio (Original / Reharm) plus a dedicated Play button so the
 * user can compare the two versions ear-to-ear.
 */
export const ReharmAbToggle: FC<ReharmAbToggleProps> = props => {
  const { hasReharm, abMode, onModeChange, onPlay } = props

  if (!hasReharm) {
    return (
      <Button variant="outlined" startIcon={<Play />} onClick={onPlay}>
        Hear original
      </Button>
    )
  }

  return (
    <div className={styles.row}>
      <div className={styles.toggleGroup} role="group" aria-label="Audition source">
        <button
          type="button"
          aria-pressed={abMode === 'original'}
          className={`${styles.segment} ${abMode === 'original' ? styles.segmentActive : ''}`}
          onClick={() => onModeChange('original')}
        >
          Original
        </button>
        <button
          type="button"
          aria-pressed={abMode === 'reharm'}
          className={`${styles.segment} ${abMode === 'reharm' ? styles.segmentActive : ''}`}
          onClick={() => onModeChange('reharm')}
        >
          Reharm
        </button>
      </div>
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<Play />}
        aria-label="Play"
        onClick={onPlay}
      >
        Play
      </Button>
    </div>
  )
}
